@import "../../global/gx-ide-mixins.scss";
@import "../../global/temporary-mercury-overrides/_button.scss";
@import "../../../node_modules/@genexus/mercury/dist/assets/scss/helpers.scss";

:host {
  container-type: inline-size;
  display: grid;
  block-size: 100%;
  overflow: auto;
  grid-template-rows: max-content 1fr max-content;
}
.section {
  display: contents;
}

// - - - - - - - - - - - -
// Header
// - - - - - - - - - - - -

// First row
.header {
  grid-template-areas:
    "name module-folder"
    "advanced-filter-accordion advanced-filter-accordion";
  grid-template-columns: 1fr 1fr;
  grid-auto-rows: max-content max-content;
}

// Accordion Advanced Filter
.name {
  grid-area: name;
}
.module-folder {
  grid-area: module-folder;
}
.advanced-filter-accordion {
  grid-area: advanced-filter-accordion;
}

// - - - - - - - - - - - -
// Main
// - - - - - - - - - - - -

.main {
  --sidebar-width: 376px;
  display: grid;
  grid-template-columns: 1fr var(--sidebar-width);
  overflow: auto;
  padding-block-start: var(--size-16);
}

.main__grid {
  overflow: auto;
  position: relative;
}
.tabular-grid-ww-images {
  overflow: auto;
  border-inline-end: var(--section-common-border);
}

ch-tabular-grid-rowset-empty {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  inline-size: 100%;
  z-index: 1;
}

// main aside
.main__aside {
  overflow: auto;
  display: grid;
  grid-template-rows: max-content 1fr;
}
.main__filter {
  display: grid;
  grid-auto-rows: max-content;
  grid-template-columns: 1fr 1fr 1fr;
  grid-template-areas:
    "category options after"
    "style language user"
    "density layer date-time"
    "search-by-contents search-by-contents button-reset";
  overflow: auto;
}
.category {
  grid-area: category;
}
.options {
  grid-area: options;
}
.after-date-time {
  grid-area: after;
}
.user {
  grid-area: user;
}
.date-time {
  grid-area: date-time;
}
.style {
  grid-area: style;
}
.language {
  grid-area: language;
}
.density {
  grid-area: density;
}
.layer {
  grid-area: layer;
}
.search-by-contents {
  grid-area: search-by-contents;
}
.button-reset {
  grid-area: button-reset;
  align-self: end;
  justify-self: end;
}

// - - - - - - - - - - - -
// Images Grid
// - - - - - - - - - - - -

.main__images-container {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: var(--size-8);
  position: relative;
  z-index: 1;

  .figure {
    margin: 0;
    background-color: var(--color-accent-surface-elevation-2);
    display: grid;
    grid-template-rows: minmax(0, 1fr) max-content;
    gap: var(--size-4);
    padding: var(--size-8);
    border-radius: var(--size-4);
    opacity: 0;
    animation: fadeIn 300ms forwards;
    aspect-ratio: 1 / 1;
  }
  .figure__picture {
    display: flex;
    align-items: center;
    justify-content: center;
    min-block-size: 0;
  }
  .figure__img {
    display: block;
    max-inline-size: 100%;
    max-block-size: 100%;
    inline-size: auto;
    block-size: auto;
    object-fit: contain;
  }
  .figure__figcaption {
    text-align: center;
    font-size: var(--font-size-body-xs);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    inline-size: 100%;
  }
}

@include tabular-grid-cell-layout(
  $tabular-grid-selector: ".tabular-grid-ww-images",
  $tabular-grid-cell-node-type: "text",
  $tabular-grid-cell-apply-ellipsis: true,
  $tabular-grid-affected-columns-nth-list: (
    1,
    2,
    3,
    4,
    5,
    6,
    7
  )
);

@keyframes fadeIn {
  to {
    opacity: 1;
  }
}

// - - - - - - - - - - - -
// Responsive
// - - - - - - - - - - - -

@container (max-width: 992px) {
  .main {
    --sidebar-width: 288px;
  }
  .main__images-container {
    grid-template-columns: repeat(3, 1fr);
  }
}

@container (max-width: 768px) {
  .main {
    --sidebar-width: 200px;
  }
  .main__images-container {
    grid-template-columns: repeat(2, 1fr);
  }
}

@container (max-width: 640px) {
  .main {
    --sidebar-width: 112px;
  }
  .main__images-container {
    grid-template-columns: 1fr;
  }
}
